export const getEnv = () => {
  const host = window.location.host;

  if (/^tunag.jp/.test(host)) {
    return "production";
  } else if (/^staging\d?.tunag.jp/.test(host)) {
    return "staging";
  } else {
    return "development";
  }
};
